export const API_URL = 'sigevents/incidents'
export const ROUTE_NAME = 'sigevents/incidents'
